import React, { useState } from 'react';
import './Charts.css';
import { formatIndianCurrency } from '../../../utils/currencyFormatter';

const StaffLeaderboard = ({ waiterStats, chefStats }) => {
  const [activeTab, setActiveTab] = useState('waiters');

  const stats = activeTab === 'waiters' ? waiterStats : chefStats;
  const columns = activeTab === 'waiters' 
    ? ['Rank', 'Name', 'Orders', 'Sales', 'Avg Service', 'Rating', 'Performance']
    : ['Rank', 'Name', 'Items Prep', 'Avg Prep Time', 'Accuracy', 'Performance'];

  const getMedalEmoji = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return `#${rank}`;
  };

  const getPerformanceClass = (performance) => {
    const perf = parseInt(performance);
    if (perf >= 90) return 'excellent';
    if (perf >= 80) return 'good';
    if (perf >= 70) return 'average';
    return 'below-average';
  };

  return (
    <div className="chart-container">
      <div className="leaderboard-header">
        <h3 className="chart-title">Staff Performance Leaderboard</h3>
        <div className="leaderboard-tabs">
          <button
            className={`tab-btn ${activeTab === 'waiters' ? 'active' : ''}`}
            onClick={() => setActiveTab('waiters')}
          >
            👨‍🍳 Waiters
          </button>
          <button
            className={`tab-btn ${activeTab === 'chefs' ? 'active' : ''}`}
            onClick={() => setActiveTab('chefs')}
          >
            🧑‍🍳 Chefs
          </button>
        </div>
      </div>

      <div className="leaderboard-table-container">
        <table className="leaderboard-table">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th key={idx}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {stats && stats.map((staff, index) => (
              <tr key={staff.id} className={index < 3 ? 'top-performer' : ''}>
                <td className="rank-cell">
                  <span className="rank-badge">{getMedalEmoji(index + 1)}</span>
                </td>
                <td className="name-cell">{staff.name}</td>
                {activeTab === 'waiters' ? (
                  <>
                    <td>{staff.ordersServed}</td>
                    <td>{formatIndianCurrency(staff.salesGenerated, true, 1)}</td>
                    <td>{staff.avgServiceTime} min</td>
                    <td>
                      <span className="rating">⭐ {staff.customerRating}</span>
                    </td>
                    <td>
                      <span className={`performance-badge ${getPerformanceClass(staff.performance)}`}>
                        {staff.performance}%
                      </span>
                    </td>
                  </>
                ) : (
                  <>
                    <td>{staff.itemsPrepared}</td>
                    <td>{staff.avgPrepTime} min</td>
                    <td>{staff.accuracy}%</td>
                    <td>
                      <span className={`performance-badge ${getPerformanceClass(staff.performance)}`}>
                        {staff.performance}%
                      </span>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {activeTab === 'waiters' && waiterStats && waiterStats.length > 0 && (
        <div className="leaderboard-insights">
          <div className="insight-item">
            <span className="insight-label">Top Earner:</span>
            <span className="insight-value">
              {waiterStats[0].name} - {formatIndianCurrency(waiterStats[0].salesGenerated, true, 1)}
            </span>
          </div>
          <div className="insight-item">
            <span className="insight-label">Best Rating:</span>
            <span className="insight-value">
              {[...waiterStats].sort((a, b) => parseFloat(b.customerRating) - parseFloat(a.customerRating))[0].name} - ⭐ {[...waiterStats].sort((a, b) => parseFloat(b.customerRating) - parseFloat(a.customerRating))[0].customerRating}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default StaffLeaderboard;

